/* SelmaCilek ürün sayfası — Faz 5 mockup'ından */
(function () {
  var root = document.getElementById('scp');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('scpData').textContent); } catch (e) {}
  var P = DATA.product || {};
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = DATA.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function withDelims(x, dec, th, dp) {
      var parts = x.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dp);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withDelims(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      return withDelims(n, 2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    var u = typeof src === 'string' ? src : (src.src || src.url || '');
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }

  // --- galeri ilerleme
  var track = $('#scpTrack'), bar = $('#scpBar'), gc = $('#scpCount');
  var N = track ? track.children.length : 0;
  function prog() {
    if (!track || !N) return;
    var w = track.scrollWidth - track.clientWidth; var p = w > 0 ? track.scrollLeft / w : 0;
    bar.style.width = (100 / N) + '%'; bar.style.transform = 'translateX(' + (p * (N - 1) * 100) + '%)';
    gc.textContent = (Math.round(p * (N - 1)) + 1) + ' / ' + N;
  }
  if (track) { track.addEventListener('scroll', prog, { passive: true }); window.addEventListener('resize', prog); prog(); }

  // --- katmanlar
  var scrim = $('#scpScrim'), openEl = null, lastFocus = null;
  function open(el) {
    if (openEl && openEl !== el) close(true);
    lastFocus = document.activeElement; el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('on'); scrim.classList.add('on'); });
    openEl = el; var f = $('.scp-x', el); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function close(keep) {
    if (!openEl) return; var el = openEl; el.classList.remove('on'); if (!keep) scrim.classList.remove('on');
    setTimeout(function () { if (!el.classList.contains('on')) el.hidden = true; }, 360);
    openEl = null; if (!keep && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  scrim.addEventListener('click', function () { close(); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { close(); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!$('#scpZoom').hidden) { closeZoom(); return; }
    close();
  });
  $$('[data-guide]').forEach(function (b) { b.addEventListener('click', function () { var g = $('#scpGuide'); if (g) { open(g); g.scrollTop = 0; } }); });

  // --- bildirim
  var tt;
  function toast(html) {
    var t = $('#scpToast'); t.innerHTML = html; t.classList.add('on'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }

  // --- sepete ekle
  function addToCart(variantId, title) {
    return fetch(R + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var item = (j.items && j.items[0]) || j;
        var drawer = document.getElementById('CartDrawer');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        if (!drawer) toast('Sepete eklendi · ' + esc(title) + ' <a href="' + R + 'cart" style="color:#fff">Sepeti gör</a>');
      })
      .catch(function (err) { toast(esc((err && (err.description || err.message)) || 'Sepete eklenemedi. Lütfen tekrar deneyin.')); });
  }

  // --- beden listesi
  function sizeSheet(prod) {
    var list = $('#scpSlist'), vs = prod.variants || [];
    $('#scpSizeFor').textContent = prod.id === P.id ? '' : prod.title;
    list.innerHTML = vs.map(function (v) {
      return '<li><button class="scp-sb" type="button" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '><span>' + esc(v.title) + '</span><span class="scp-st">' + (v.available ? '' : 'Tükendi') + '</span></button></li>';
    }).join('');
    $$('[data-vid]', list).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = vs.filter(function (x) { return String(x.id) === b.dataset.vid; })[0];
        close(); setTimeout(function () { addToCart(b.dataset.vid, prod.title + ' · ' + (v ? v.title : '')); }, 220);
      });
    });
    open($('#scpSize'));
  }
  function startAdd(prod) {
    var vs = prod.variants || [];
    if (vs.length === 1) { if (vs[0].available) addToCart(vs[0].id, prod.title); return; }
    sizeSheet(prod);
  }
  var atc = $('#scpAtc'), t1btn = $('#scpT1btn');
  if (atc) atc.addEventListener('click', function () { startAdd(P); });
  if (t1btn) t1btn.addEventListener('click', function () { startAdd(P); });
  $$('[data-addh]').forEach(function (b) {
    b.addEventListener('click', function () {
      fetch(R + 'products/' + b.dataset.addh + '.js').then(function (r) { return r.json(); }).then(startAdd);
    });
  });

  // --- sabit alt çubuk
  var t1 = $('#scpT1bar'), buy = $('#scpBuy');
  if (t1 && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
      t1.classList.toggle('on', show); t1.setAttribute('aria-hidden', String(!show)); if (t1btn) t1btn.tabIndex = show ? 0 : -1;
    }, { threshold: 0 }).observe(buy);
  }

  // --- ikon bilgileri
  $$('#scpIcons [data-ti]').forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-expanded') !== 'true', ti = $('#scpTinfo');
      $$('#scpIcons [data-ti]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      if (on) { b.setAttribute('aria-expanded', 'true'); ti.innerHTML = $('#scpTi' + b.dataset.ti).innerHTML; ti.hidden = false; } else ti.hidden = true;
    });
  });

  // --- sekmeler
  var tabs = $$('.scp-tabs [role=tab]');
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { tabs.forEach(function (x, j) { x.setAttribute('aria-selected', String(j === i)); document.getElementById(x.getAttribute('aria-controls')).hidden = (j !== i); }); });
    t.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return; var n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); n.click(); });
  });

  // --- büyütme: yalnızca masaüstünde (fare). Telefonda / dokunmatikte dokunmak bir şey yapmaz; kaydırma şeridi aynen çalışır.
  var noZoom = window.matchMedia('(max-width: 768px), (hover: none)');
  var zoomImgs = $$('.scp-track [data-z] img'), zs = $('#scpZs');
  function zc() { $('#scpZc').textContent = (Math.round(zs.scrollLeft / Math.max(1, zs.clientWidth)) + 1) + ' / ' + zoomImgs.length; }
  function openZoom(i) {
    zs.innerHTML = zoomImgs.map(function (im) { var s = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2000'); return '<div class="scp-zi"><img src="' + s + '" alt="' + esc(im.alt) + '"></div>'; }).join('');
    $('#scpZoom').hidden = false; document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { zs.scrollLeft = i * zs.clientWidth; zc(); }); $('#scpZx').focus();
  }
  function closeZoom() { $('#scpZoom').hidden = true; document.documentElement.style.overflow = ''; }
  zs.addEventListener('scroll', zc, { passive: true });
  $$('.scp-track [data-z]').forEach(function (b) { b.addEventListener('click', function () { if (noZoom.matches) return; openZoom(zoomImgs.indexOf($('img', b))); }); });
  $('#scpZx').addEventListener('click', closeZoom);
  // ekran okuyucu: büyütme yoksa düğme adında "zoom" geçmez
  function zoomLabel() {
    $$('.scp-track [data-z]').forEach(function (b) { var l = (b.getAttribute('aria-label') || '').replace(/, büyüt$/, ''); b.setAttribute('aria-label', noZoom.matches ? l : l + ', büyüt'); });
  }
  zoomLabel();
  if (noZoom.addEventListener) noZoom.addEventListener('change', zoomLabel);

  // --- renkler: aynı addaki diğer ürünler
  var COL = { siyah: '#151515', beyaz: '#F4F2EE', 'kırık': '#EFE9DC', ekru: '#E9E2D3', krem: '#EFE7D6', bej: '#D8C8AE', 'taş': '#BDB5A6', tas: '#BDB5A6', vizon: '#A39383', kahve: '#5B4032', 'çikolata': '#4A3226', 'yeşil': '#4F5B3A', zeytin: '#5C5B3A', lacivert: '#1F2A44', mavi: '#3E5A7E', gri: '#8C8C8C', antrasit: '#3C3C3C', bordo: '#6D1F2A', 'kırmızı': '#A32A2A', pembe: '#D9A7A7', 'fuşya': '#C2266E', lila: '#B7A6C9', mor: '#5E3A6E', 'sarı': '#D9B84A', turuncu: '#D9783A', hardal: '#C49A2C', 'gümüş': '#C0C0C0', 'altın': '#C9A94E', black: '#151515', white: '#F4F2EE', ecru: '#E9E2D3', cream: '#EFE7D6', beige: '#D8C8AE', stone: '#BDB5A6', camel: '#B08B5E', brown: '#5B4032', kahverengi: '#5B4032', khaki: '#56593F', haki: '#56593F', green: '#4F5B3A', olive: '#5C5B3A', navy: '#1F2A44', blue: '#3E5A7E', grey: '#8C8C8C', gray: '#8C8C8C', burgundy: '#6D1F2A', red: '#A32A2A', pink: '#D9A7A7', lilac: '#B7A6C9', yellow: '#D9B84A' };
  // Faz 2 (16 Eki 2026): öneri kartlarında renksiz kısa ad (JSON'da metafield yok; renk kelimeleri çıkarılır)
  var SC_COLORS = ['siyah','beyaz','ekru','krem','bej','taş','vizon','camel','taba','kahverengi','kahve','bordo','kırmızı','pembe','pudra','fuşya','mor','lila','mavi','lacivert','saks','parlament','yeşil','haki','mint','sarı','turuncu','gri','antrasit','karışık','açık','koyu'];
  function scShort(title) {
    var w = String(title).split(/\s+/);
    if (w.length < 3) return String(title);
    var out = [w[0]];
    for (var i = 1; i < w.length; i++) { if (SC_COLORS.indexOf(w[i].toLocaleLowerCase('tr')) === -1) out.push(w[i]); }
    return out.join(' ');
  }
  function colorOf(title, base) {
    var w = String(title).split(/\s+/); if (w.length < 3) return '';
    return w.slice(1, -1).join(' ').replace(new RegExp('^' + base + '\\s*', 'i'), '');
  }
  var base = root.dataset.base, ptype = (root.dataset.type || '').toLowerCase(), cname = $('#scpColorName'), cur = root.dataset.color;
  if (base) {
    fetch(R + 'search/suggest.json?q=' + encodeURIComponent(base) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = ((j.resources || {}).results || {}).products || [];
        ps = ps.filter(function (p) { return String(p.title).split(/\s+/)[0].toLowerCase() === base.toLowerCase() && (!ptype || String(p.type || '').toLowerCase() === ptype); });
        if (ps.length < 2) return;
        var sw = $('#scpSw');
        sw.innerHTML = ps.map(function (p) {
          var c = colorOf(p.title, base), hex = null;
          c.toLowerCase().split(/\s+/).forEach(function (w) { if (!hex && COL[w]) hex = COL[w]; });
          var style = hex ? '--c:' + hex : 'background-image:url(' + img(p.image, 80) + ')';
          var here = p.handle === root.dataset.handle;
          return '<a role="listitem" href="' + p.url.split('?')[0] + '" style="' + style + '" aria-label="' + esc(c || p.title) + '" data-c="' + esc(c) + '"' + (here ? ' aria-current="true"' : '') + '></a>';
        }).join('');
        $$('a', sw).forEach(function (a) {
          a.addEventListener('mouseenter', function () { cname.textContent = a.dataset.c || cur; });
          a.addEventListener('mouseleave', function () { cname.textContent = cur || '—'; });
        });
      }).catch(function () {});
  }

  // --- kartlar
  // Fotoğraf aynı alan adından (/cdn/shop/...) gelir: sc-grid.js zemin tonunu ölçebilir. Dosya dekupe listesindeyse
  // (window.scCutList, snippets/sc-cut-list) .sc-cut / .sc-cutbox baştan eklenir.
  function local(u) { return u.replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/1\/\d+\/\d+\/\d+\/(files|products)\//, '/cdn/shop/$2/'); }
  function card(p) {
    var im = p.featured_image || (p.images && p.images[0]) || p.image;
    var src = local(img(im, 600)), f = src.split('?')[0].split('/').pop();
    var cut = typeof window.scCutList === 'string' && window.scCutList.indexOf('|' + f + '|') > -1;
    var png = !cut && src.toLowerCase().indexOf('.png') > -1;
    return '<a class="scp-card" href="' + (p.url || (R + 'products/' + p.handle)).split('?')[0] + '"><span class="scp-cimg' + (cut ? ' sc-cutbox' : png ? ' is-png' : '') + '"><img src="' + src + '" alt="" loading="lazy"' + (cut ? ' class="sc-cut"' : '') + '></span><div class="scp-n">' + esc(scShort(p.title)) + '</div><div class="scp-p">' + money(p.price) + '</div></a>';
  }

  // benzer ürünler: metafield boşsa Shopify önerileri
  // Kural D (17 Eki 2026): Outlet ürünü yalnızca Outlet önerir; sezon ürünü Outlet önermez.
  function isOutlet(p) { var t = p && p.tags; if (!t) return false; if (typeof t === 'string') t = t.split(/\s*,\s*/); return t.indexOf('Outlet') > -1; }
  var rel = $('#scpRel');
  if (rel && !rel.children.length) {
    fetch(R + 'recommendations/products.json?product_id=' + P.id + '&limit=10')
      .then(function (r) { return r.json(); })
      .then(function (j) { var me = isOutlet(P); var ps = (j.products || []).filter(function (p) { return isOutlet(p) === me; }).slice(0, 8); if (!ps.length) { $('#scpRelSec').hidden = true; return; } rel.innerHTML = ps.map(card).join(''); })
      .catch(function () { $('#scpRelSec').hidden = true; });
  }

  // son baktıklarınız
  var KEY = 'scp_rv', list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
  var others = list.filter(function (h) { return h !== P.handle; }).slice(0, 8);
  try { localStorage.setItem(KEY, JSON.stringify([P.handle].concat(others).slice(0, 12))); } catch (e) {}
  if (others.length) {
    Promise.all(others.map(function (h) { return fetch(R + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) { ps = ps.filter(Boolean); if (!ps.length) return; $('#scpRec').innerHTML = ps.map(card).join(''); $('#scpRecSec').hidden = false; });
  }

  // --- favoriler: kalp (#scpFav) Growave Wishlist ile assets/sc-fav.js tarafından yönetilir (her sayfada yüklenir).

  // --- masaüstü: sağ sütun yapışkan siyah başlığın (--sc-header-h) altında durur; uzunsa alttan yapışır
  var inf = $('#scpInfo');
  function infoTop() { if (window.innerWidth >= 900) inf.style.top = 'min(var(--sc-header-h, var(--scf-top, 0px)), ' + (window.innerHeight - inf.offsetHeight - 24) + 'px)'; else inf.style.top = ''; }
  window.addEventListener('resize', infoTop); window.addEventListener('load', infoTop); infoTop();
  if (window.ResizeObserver) new ResizeObserver(infoTop).observe(inf);
})();
